import Vue from 'vue'
import Vuex from 'vuex'
import * as Cookies from 'vue-cookie'

Vue.use(Vuex)
Vue.use(Cookies)

export default new Vuex.Store({
    state: {
        logged: false,
        loading: false,
        data: {},
        token: ''
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload
        },
        authenticated: function (state, payload) {
            window.localStorage.setItem('c_extra', JSON.stringify(payload))
            if (payload.token) {
                state.data = payload.data
                state.token = payload.token
                state.logged = true
            }
        },
        refreshSession: function (state, payload) {
            if (payload.token) {
                state.data = payload.data
                state.token = payload.token
                state.logged = true
            }
        },
        logout: function (state) {
            state.data = {}
            state.token = ''
            Cookies.delete('c_extra')
            state.logged = false
        },
    },
    actions: {},
    geeters: {
        isAuthenticated(state) {
            return (state.logged) ? true : false
        },
        getUsername(state) {
            return state.data.username
        }
    }
})
